import request from '@/utils/request';

export function check(data) {
  return request({
    url: '/api/guaratee/verification/check',
    method: 'post',
    data,
  });
}


export default { check };
